<template>
  <div class="form-group">
    <label :for="name" class="block text-sm font-medium text-gray-700">{{ label }}</label>
    <div class="mt-1">
      <select
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        class="form-select block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
        required
      >
        <option v-for="item in items" :key="item.id" :value="item.id">
          {{ getItemName(item) }}
        </option>
      </select>
    </div>
  </div>
</template>
  
<script setup>
  import { onMounted, watch } from 'vue'

  const props = defineProps({
    modelValue: {
      type: [Number, String],
      required: false
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    items: {
      type: Array,
      required: true
    },
    nameKey: {
      type: String,
      default: 'name'
    }
  })
  
  defineEmits(['update:modelValue'])
  
  const getItemName = (item) => {
    if (props.nameKey === 'attributes.name') {
      return item.attributes.name
    }
    return item[props.nameKey]
  }


  watch(()=> props.items, (newItems) => {
    console.log("newItems", newItems)
  })  
</script> 